import { observable, action } from 'mobx'
import Api from '@api/xiu_yan/bondApi'
import systemApi from '@api/system'
import { message } from 'hljd'
import { MARKETING_CENTER_PATH_A } from '@constant'

class Store {
  @observable disabled = false

  @observable
  shop = {
    name: '',
    bond_fee: '',
    property: {},
    withdraw: '',
    pay_money: '',
    tab_key: '1'
  }

  @action
  getBaseData = async () => {
    let res = await systemApi.shopInfo()
    this.shop.name = res.data.name
    this.shop.bond_fee = res.data.bond_fee
    this.shop.property = res.data.property
  }

  @action
  getBondData = async () => {
    let res = await Api.shopBond()
    this.shop.withdraw = res.data.money
    this.shop.pay_money = res.data.pay_money
    this.shop.tab_key = res.data.money - res.data.pay_money < 0 ? '2' : '1'

    if (res.data.money - res.data.pay_money < 0) {
      this.disabled = true
    } else {
      this.disabled = false
    }
  }

  @action
  payBond = async (params, type) => {
    if (type == 'wallet') {
      this.disabled = true
    }
    let res = await Api.payBond(params)

    if (res && res.RetCode == 0) {
      if (type == 'card') {
        document.write(res.data.pay_params)
      } else if (type == 'wallet') {
        if (res.data.pay_success == 1) {
          message.success('支付成功')
          setTimeout(() => {
            window.location.href = MARKETING_CENTER_PATH_A
            window.location.reload()
          }, 1000)
        }
      }
    } else {
      message.error('支付失败')
    }
  }
}
export default new Store()
